import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getUserById } from "../../apis"; // Ensure this import matches your actual API import
import actions from "../../actions";
import "./UserDetails.css";
import CategoryPage from "../Categories/index";
import Subcategories from "../Subcategories";
import Planner from "../Planner";
import ChatHistory from "../ChatHistory";
import AiChat from "../AiChat";

import Pagination from "@mui/material/Pagination"; // MUI Pagination
import Moodboard from "../Moodboard";
import Wardrobes from "../Wardrobes";
import Outfits from "../outfits";
import SupportHistory from "../SupportHistory";
import ChatHistoryTable from "../ChatHistory/ChatHistoryTable";
import AiChatHistoryTable from "../AiChat/AiChatHistoryTable";
import SupportHistoryChatTable from "../SupportHistory/SupportHistoryChatTable";
import PermissionHistoryTable from "../ChatHistory/PermissionTable";
import Analytics from "./Analytics";

const UserDetails = ({
  logoutRequest,
  startLoadingRequest,
  stopLoadingRequest,
  deactivateSidebarRequest,
}) => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("wardrobe");
  const [currentPage, setCurrentPage] = useState(1); // Current page state
  const itemsPerPage = 5; // Number of items per page
  const adminDetails=JSON.parse(localStorage.getItem("userDetails"))
  const userManagementPermissions=adminDetails?.role?.userManagementPermissions||[]
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        startLoadingRequest();
        const response = await getUserById(id); // Make the API call to get user details
        setUser(response.data.data); // Set the response data to the state
        deactivateSidebarRequest();
      } catch (error) {
        toast.error("Failed to fetch user details");
      } finally {
        stopLoadingRequest();
        setLoading(false);
      }
    };
    fetchUserDetails();
  }, [id, startLoadingRequest, stopLoadingRequest]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <div>User not found</div>;
  }

  // Function to handle pagination logic using slice
  const paginateItems = (items = []) => {
    if (!Array.isArray(items) || !items.length) return [];
    return items.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  };

  // Handle page change
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const renderWardrobe = () => {
    const wardrobeItems = user?.waredrob || [];
    if (wardrobeItems.length === 0) {
      return <p>No wardrobe items found.</p>;
    }
    const currentWardrobeItems = paginateItems(wardrobeItems);
    const totalWardrobePages = Math.ceil(wardrobeItems.length / itemsPerPage);

    return (
      <>
        <div className="wardrobe-list">
          {currentWardrobeItems.map((item) => (
            <div key={item._id} className="wardrobe-item">
              <img
                src={item?.image}
                alt={item?.name}
                className="wardrobe-image"
              />
              <div className="wardrobe-details">
                <h3>{item?.name}</h3>
                <p>
                  <strong>Brand:</strong> {item?.brand}
                </p>
                <p>
                  {item?.price !== 0 && (
                    <strong>Price: Rs {item?.price}</strong>
                  )}
                </p>
                <p>
                  <strong>Size:</strong> {item?.size}
                </p>
                <p>
                  <strong>Primary Color:</strong> {item?.primaryColorName}
                </p>
                <p>
                  <strong>Secondary Color:</strong> {item?.secondaryColorName}
                </p>
                <p>
                  <strong>Description:</strong> {item?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="pagination-container">
          <Pagination
            count={totalWardrobePages} // Total number of pages
            page={currentPage} // Current page number
            onChange={handlePageChange} // Handle page change
            color="primary"
          />
        </div>
      </>
    );
  };

  const renderOutfit = () => {
    const outfitItems = user?.outfits || [];
    if (outfitItems.length === 0) {
      return <p>No outfits found.</p>;
    }
    const currentOutfitItems = paginateItems(outfitItems);
    const totalOutfitPages = Math.ceil(outfitItems.length / itemsPerPage);

    return (
      <>
        <div className="wardrobe-list">
          {currentOutfitItems.map((item) => (
            <div key={item._id} className="wardrobe-item">
              <img
                src={item?.image}
                alt={item?.name}
                className="wardrobe-image"
              />
              <div className="wardrobe-details">
                <h3>{item?.name}</h3>
                <p>
                  <strong>Brand:</strong> {item?.brand}
                </p>
                <p>
                  <strong>Price:</strong> ${item?.price}
                </p>
                <p>
                  <strong>Size:</strong> {item?.size}
                </p>
                <p>
                  <strong>Primary Color:</strong> {item?.primaryColorName}
                </p>
                <p>
                  <strong>Secondary Color:</strong> {item?.secondaryColorName}
                </p>
                <p>
                  <strong>Description:</strong> {item?.description}
                </p>
                <p>
                  <strong>Tags:</strong>{" "}
                  {item?.tags?.map((tag) => (
                    <span key={tag}>{tag}</span>
                  ))}
                </p>
                <p>
                  <strong>Instructions:</strong>{" "}
                  {item?.instructions?.map((instruction) => (
                    <span key={instruction}>{instruction}</span>
                  ))}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="pagination-container">
          <Pagination
            count={totalOutfitPages} // Total number of pages
            page={currentPage} // Current page number
            onChange={handlePageChange} // Handle page change
            color="primary"
          />
        </div>
      </>
    );
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "wardrobe":
        // return renderWardrobe();
        return <Wardrobes />;
      case "outfits":
        // return renderOutfit();
        return <Outfits />;
      case "planner":
        return <Planner />;
      case "Category":
        return <CategoryPage />;
      case "Subcategory":
        return <Subcategories />;
      case "Moodboard":
        return <p><Moodboard /></p>;
      case "ChatHistory":
        return <ChatHistoryTable/>;
      case "Ai Chat":
        return <AiChatHistoryTable />;
      case "supportHistory":
        return <SupportHistoryChatTable />
      case "wardrobePermissionHistory":
        return <PermissionHistoryTable />;
      case "userAnalytics":
        return <p><Analytics /></p>;
      default:
        return <p>Unknown tab.</p>;
    }
  };

  function formatDate(dateInput) {
    const date = new Date(dateInput);
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'long' }).toLowerCase();
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day} ${month} ${year} - ${hours}:${minutes}`;
  }
  console.log("user",userManagementPermissions)
  
  // const defaultUserImg = "https://i.pinimg.com/736x/b9/e0/e3/b9e0e30ac1ec95077b7e1d0abd250e5d.jpg"
  const defaultUserImg="/images/user.png"
  const preferenceMap=(preference)=>{
    switch (preference){
      case "Men":
        return "Menswear"
      case "Women":
        return "Women swear"
      default:
        return "Unisex"
    }
  }

  return (
    <div className="user-details-container">
      <div className="user-details-left">
    <div className="user-card">
      <div className="user-image">
        {(user?.image?.includes('http')&&adminDetails?.role?.name==="super admin") ? <img src={user?.image} alt="User" /> : <img src={ defaultUserImg} alt="User" /> }
        
        <div className="overlay">
         {user.firstName && <h2>{`${user.firstName} ${user.lastName} `}<span style={{transform:'scale(0.4)',margin:'-4px',position:'absolute',opacity:'0.8'}}>{`${user.isActive && '🟢'}`}</span></h2>} 
        </div>
      </div>
      <div className="user-details">
        <p><strong>Username:</strong> {user.username || "N/A"}</p>
       {adminDetails?.role?.name==="super admin"&& <p><strong>Email:</strong> {user.email || "N/A"}</p>}
        <p><strong>Status:</strong> {user.isActive ? "🟢 Active" : "🔴 In Active"}</p>
    
        {/* <p><strong>Deletion Requested At:</strong> {user.deletionRequestedAt || "N/A"}</p>
        <p><strong>Pending Deletion:</strong> {user.isPendingDeletion ? "Yes" : "No"}</p> */}
       
        {/* <p><strong>Version:</strong> {user.__v}</p> */}
        <p><strong>Country:</strong> {user.country || "N/A"}</p>
       {adminDetails?.role?.name==="super admin"&& <p><strong>Age:</strong> {user.dob || "N/A"}</p>}
       {adminDetails?.role?.name==="super admin"&& <p><strong>Style Preference:</strong> {preferenceMap(user.stylePreference || "N/A")}</p>}
        {/* <p><strong>Role:</strong> {user.role || "N/A"}</p> */}
       {adminDetails?.role?.name==="super admin"&& <p><strong>Phone Number:</strong> {user.phoneNumber || "N/A"}</p>}
        {/* <p><strong>Language:</strong> {user.language || "N/A"}</p> */}
       {adminDetails?.role?.name==="super admin"&& <p><strong>Share Count:</strong> {user.shareCount}</p>}
       {adminDetails?.role?.name==="super admin"&& <p><strong>Notifications Enabled:</strong> {user.notification ? "Yes" : "No"}</p>}
        {/* <p><strong>Details Filled:</strong> {user.filledDetails ? "Yes" : "No"}</p>
        <p><strong>Is Deleted:</strong> {user.isDeleted ? "Yes" : "No"}</p> */}
        <p>
          <strong>Created At:</strong> {formatDate(user.createdAt)}
        </p>
        <p>
          <strong>Updated At:</strong> {formatDate(user.updatedAt)}
        </p>
      </div>
    </div>
  </div>

      <div className="user-details-right">
        <div className="tabs">
          <button
            onClick={() => setActiveTab("wardrobe")}
            className={activeTab === "wardrobe" ? "active" : ""}
          >
            Wardrobe
          </button>
          <button
            onClick={() => setActiveTab("outfits")}
            className={activeTab === "outfits" ? "active" : ""}
          >
            Outfits
          </button>
          <button
            onClick={() => setActiveTab("planner")}
            className={activeTab === "planner" ? "active" : ""}
          >
            Planner
          </button>
         {userManagementPermissions?.includes("category")&& <button
            onClick={() => setActiveTab("Category")}
            className={activeTab === "Category" ? "active" : ""}
          >
            Category
          </button>}
         {userManagementPermissions?.includes("subCategory")&& <button
            onClick={() => setActiveTab("Subcategory")}
            className={activeTab === "Subcategory" ? "active" : ""}
          >
            Subcategory
          </button>}
         {userManagementPermissions?.includes("moodboard")&& <button
            onClick={() => setActiveTab("Moodboard")}
            className={activeTab === "Moodboard" ? "active" : ""}
          >
            Moodboard
          </button>}
         {userManagementPermissions?.includes("stylistChatHistory")&& <button
            onClick={() => 
            { 
              setActiveTab("ChatHistory")}
            }
            className={activeTab === "ChatHistory" ? "active" : ""}
          >
           Stylist Chat History
          </button>}
         {userManagementPermissions?.includes("aiChat")&& <button
            onClick={() => setActiveTab("Ai Chat")}
            className={activeTab === "Ai Chat" ? "active" : ""}
          >
            AI Chat
          </button>}
         {userManagementPermissions?.includes("supportChat")&& <button
            onClick={() => setActiveTab("supportHistory")}
            className={activeTab === "supportHistory" ? "active" : ""}
          >
            Support History
          </button>}
         {userManagementPermissions?.includes("permissionHistory")&& <button
            onClick={() => setActiveTab("wardrobePermissionHistory")}
            className={activeTab === "wardrobePermissionHistory" ? "active" : ""}
          >
            Permission History
          </button>}
         {userManagementPermissions?.includes("userStats")&& <button
            onClick={() => setActiveTab("userAnalytics")}
            className={activeTab === "userAnalytics" ? "active" : ""}
          >
            User Stats
          </button>}
        </div>
        {renderTabContent()}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutRequest: actions.auth.logout,
      stopLoadingRequest: actions.loader.stopLoading,
      startLoadingRequest: actions.loader.startLoading,
      deactivateSidebarRequest: actions.sidebar.deactivateSidebar,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(UserDetails);
